











































import Vue from 'vue';
import filterParams from '@/components/table/utils/filterParameters';
import { mapGetters } from 'vuex';
import Tabs from '@/components/widgets/Tabs.vue';
import { ICollectionTabsData, TCollectionIcons } from '@/types';
import truffleKitIcons from '@/utils/truffleKitIcons';
import { EAccountTabs } from '@/types/auth/account';

export default Vue.extend({
  name: 'Account',
  components: {
    Tabs,
    TheProfile: () => import('@/components/user/account/TheProfile.vue'),
    TheSettings: () => import('@/components/user/account/TheSettings.vue'),
  },

  async created() {
    await Promise.all([
      this.$store.dispatch('getProfile', this.dataProfile),
      this.$store.dispatch('getTimezones', { per__page: 0 }),
    ]);
    this.$store.commit('changeTitle', this.$t('pages.account.title'));
    this.currentTab = filterParams.getParamFromUrl('tab') as string;
  },

  computed: {
    ...mapGetters({
      getUser: 'getUser',
      initials: 'getInitials',
      timezones: 'getTimezoneList',
    }),
    dataProfile() {
      return {
        expand: 'name,surname,phone,timezone,language,currency',
        fields: 'id,username,email,roles,status,is_confirmed_email',
      };
    },
    activeTabName(): string {
      let tabName = this.currentTab;
      tabName = tabName?.charAt(0)?.toUpperCase() + tabName?.slice(1);

      return tabName;
    },
    profileTab(): string {
      return EAccountTabs.PROFILE;
    },
    settingsTab(): string {
      return EAccountTabs.SETTINGS;
    },
    truffleKitIcons(): TCollectionIcons {
      return truffleKitIcons;
    },
  },

  methods: {
    goBack() {
      const backUrl = filterParams.getUrlBack() || '';
      this.$router.push(backUrl);
    },
    changeCurrentTab(_, currentTab) {
      this.currentTab = currentTab;
    },
  },

  data() {
    return {
      currentTab: 'profile',
      tabsData: {
        [EAccountTabs.PROFILE]: {
          name: this.$t('pages.account.menu.profile'),
          tab: EAccountTabs.PROFILE,
          buttons: false,
        },
        [EAccountTabs.SETTINGS]: {
          name: this.$t('pages.account.menu.settings'),
          tab: EAccountTabs.SETTINGS,
          buttons: false,
        },
      } as ICollectionTabsData,
    };
  },
});
